import { Stack } from '@mantine/core';
import type { Initiative } from '../../../../api/initiative-client/initiative-client.type';
import { useGlobalStore } from '../../../../store/global-store/global-store';
import { SideSectionInfoItem } from './side-section-info-item';
import { getInitiativeInfo } from './side-section.helpers';

type Props = {
  initiative: Initiative;
};

export const SideSectionInfo = ({ initiative }: Props) => {
  const teams = useGlobalStore((state) => state.teams);

  return (
    <Stack gap={8}>
      {getInitiativeInfo(initiative, teams).map(({ label, value }) => (
        <SideSectionInfoItem key={label} label={label} value={value} />
      ))}
    </Stack>
  );
};
